import buildStructure from './structure';
import addPositioning from './position';
import { buildLinkData } from './info';
import { setOptions as setStyleOptions } from './style';

export function tracegraph() {
  function graph(traces, options) {
    setStyleOptions(options);

    const structure = buildStructure(traces, options);
    const { bounds, nodes, links } = addPositioning(structure, options);

    return {
      bounds,
      nodes,
      links: links.map((link) => ({ ...link, info: buildLinkData(link, nodes, options) }))
    };
  }

  return graph;
}
